import TruckKingCab from "./TruckKingCab";

export default TruckKingCab;